// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/components/edit-patient/components/patient-image/patient-image.less
// module id = 3776
// module chunks = 0